import { useState } from 'react'

import {
  EMPTY_FUNCTION,
  EMPTY_FUNCTION_ASYNC,
  EMPTY_LIST,
} from '../../../../constants/common'
import { DocFlowProfileHeader, DocFlowProvider } from '../../../DocFlow'
import { useFileUpload } from '../../../File'
import { Container } from '../../Container'

import {
  PROFILE_HEADER_DOCUMENT_STAPLING_ACTIVE_PHASE,
  PROFILE_HEADER_DOCUMENT_STAPLING_DOC_FLOW_MOCK,
} from './ProfileHeaderDocumentStapling.constants'

function ProfileHeaderDocumentStapling() {
  const [modal, setModal] = useState(null)
  const [files, setFiles] = useState(EMPTY_LIST)

  function handleCloseModal() {
    setModal(null)
  }

  const {
    handleStartUploading,
    handleUploadErrors,
    handleUploadFile,
    totalFilesCount,
  } = useFileUpload({
    files,
    onSetFiles: setFiles,
  })

  const uploadFooterProps = {
    files,
    totalFilesCount,
    onFinishUpload: handleUploadFile,
    onStartUpload: handleStartUploading,
    onUploadErrors: handleUploadErrors,
  }

  return (
    <>
      <Container label='ProfileHeaderDocumentStapling'>
        <DocFlowProvider
          docFlowInitiated
          activePhase={PROFILE_HEADER_DOCUMENT_STAPLING_ACTIVE_PHASE}
          asyncActionInProccess={false}
          docFlow={PROFILE_HEADER_DOCUMENT_STAPLING_DOC_FLOW_MOCK}
          footerProps={uploadFooterProps}
          handleCloseModal={handleCloseModal}
          handleNextPhase={EMPTY_FUNCTION}
          handleReloadDocFlow={EMPTY_FUNCTION_ASYNC}
          handleUpdateDocFlow={EMPTY_FUNCTION_ASYNC}
          isDocFlowLoading={false}
          setActivePhase={EMPTY_FUNCTION}
          setModal={setModal}
        >
          <DocFlowProfileHeader />
        </DocFlowProvider>
      </Container>
      <Container label='ProfileHeaderDocumentStapling, disable next phase button'>
        <DocFlowProvider
          docFlowInitiated
          activePhase={PROFILE_HEADER_DOCUMENT_STAPLING_ACTIVE_PHASE}
          asyncActionInProccess={false}
          docFlow={PROFILE_HEADER_DOCUMENT_STAPLING_DOC_FLOW_MOCK}
          footerProps={{ ...uploadFooterProps, nextPhaseDisabled: true }}
          handleCloseModal={handleCloseModal}
          handleNextPhase={EMPTY_FUNCTION}
          handleReloadDocFlow={EMPTY_FUNCTION_ASYNC}
          handleUpdateDocFlow={EMPTY_FUNCTION_ASYNC}
          isDocFlowLoading={false}
          setActivePhase={EMPTY_FUNCTION}
          setModal={setModal}
        >
          <DocFlowProfileHeader />
        </DocFlowProvider>
      </Container>
      {modal}
    </>
  )
}

export default ProfileHeaderDocumentStapling
